//const url = "http://localhost:8090/#/eedoc";
//const url = "https://gatewaysistemas.com.br/gwayhomologacao/#/eedoc";
const url = "https://gatewaysistemas.com.br/gway/#/eedoc";

export default url;
